<div
  style="
    margin-bottom: 0.25em;
    border: solid 1px #ddd;
    padding: 0.5em;
    background-color: #fff;
    font-size: 12px;
  "
>
  <!-- == -->

  <div
    fxFlex="12"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #000;
      height: 60px;
    "
  >
    <img
      *ngIf="cardContent.variety_image_url"
      style="object-fit: fill; height: 60px"
      src="{{ cardContent.variety_image_url }}"
    />

    <img
      *ngIf="!cardContent.variety_image_url"
      style="object-fit: fill; height: 60px"
      src="https://wikipapa.org/images/img-no-disponible-large.jpg"
    />
  </div>

  <!-- == -->
  <div
    fxFlex="21"
    style="display: flex; justify-content: center; align-items: center"
  >
    <div>
      <span>{{ cardContent.variety_name }}</span
      ><br />
    </div>
  </div>
  <!-- == -->
  <div
    fxFlex="21"
    style="display: flex; justify-content: center; align-items: center"
  >
    <div
      [style.width]="'40px'"
      [style.height]="'40px'"
      [style.border-radius]="'20px'"
      [style.margin-right]="'5px'"
      [style.background-size]="'cover'"
      [style.background-image]="
        cardContent.user_image_url
          ? 'url(' + cardContent.user_image_url + ')'
          : 'url(https://wikipapa.org/images/img-no-disponible.jpg)'
      "
    ></div>

    <span>{{ cardContent.username }}</span>
  </div>
  <!-- == -->
  <div
    fxFlex="15"
    style="display: flex; justify-content: center; align-items: center"
  >
    <span>{{ cardContent.species_name }}</span>
  </div>

  <!-- == -->
  <div
    fxFlex="16"
    style="display: flex; justify-content: center; align-items: center"
  >
    <span>{{ cardContent.synonyms }}</span>
  </div>

  <!-- <div
    fxFlex="12"
    style="display: flex; justify-content: center; align-items: center"
  >
    <mat-slide-toggle [(ngModel)]="cardContent.is_original">
      {{ cardContent.is_original ? "original" : "no curada" }}
    </mat-slide-toggle>
  </div> -->

  <!-- == -->
  <div
    fxFlex="15"
    style="display: flex; justify-content: center; align-items: center"
  >
    <button
      mat-button
      color="primary"
      (click)="fnEditItem(cardContent.variety_id)"
      [disabled]="cardContent.is_original ? false : true"
    >
      Editar</button
    >/
    <button mat-button color="primary" (click)="fnItem(cardContent.variety_id)">
      Ver >>
    </button>
  </div>
</div>
